export const AD_CONTENT_LEVELS = Object.freeze({
  AD: 'AD',
  AD_NAME: 'AD_NAME',
  CREATIVE: 'CREATIVE',
} as const);

export type AdContentLevel = (typeof AD_CONTENT_LEVELS)[keyof typeof AD_CONTENT_LEVELS];

export const INVALID_AD_CONTENT = 'INVALID_AD_CONTENT' as const;
